import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const RECEIVE_HABITUAL_RESIDENCE = 'RECEIVE_HABITUAL_RESIDENCE'
export const REQUEST_HABITUAL_RESIDENCE = 'REQUEST_HABITUAL_RESIDENCE'
const SAVE_HABITUAL_RESIDENCE = 'SAVE_HABITUAL_RESIDENCE'
const UPDATE_AND_SAVE_HABITUAL_RESIDENCE = 'UPDATE_AND_SAVE_HABITUAL_RESIDENCE'

export const requestHabitualResidence = (taxReturnId) => (dispatch, getState) => {
    dispatch({ type: REQUEST_HABITUAL_RESIDENCE })

    const { id: activeTaxReturnId } = getState().taxReturn
    const id = taxReturnId ?? activeTaxReturnId

    return axios
        .get(`/habitualresidences/${id}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveHabitualResidence({ ...responseData, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveHabitualResidence({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveHabitualResidence({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveHabitualResidence = (data) => ({ type: RECEIVE_HABITUAL_RESIDENCE, data })

export const updateAndSaveHabitualResidence = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_HABITUAL_RESIDENCE, data })

    dispatch(receiveHabitualResidence(data))
    return dispatch(saveHabitualResidence(data))
}

const saveHabitualResidence = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_HABITUAL_RESIDENCE })

    const { taxReturn, habitualResidence } = getState()

    const { id: taxReturnId } = taxReturn

    return axios
        .put(`/habitualresidences/${taxReturnId}`, { ...habitualResidence, ...data, taxReturnId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveHabitualResidence(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
